import { Entity, MicroMClient } from "@mcurros2/microm";
import { DatosServiciosAutorizacionReportesAppSupervisorFiltersDef } from "./DatosServiciosAutorizacionReportesAppSupervisorFiltersDef";


export class DatosServiciosAutorizacionReportesAppSupervisorFilters extends Entity<DatosServiciosAutorizacionReportesAppSupervisorFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionReportesAppSupervisorFiltersDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionReportesAppSupervisorFiltersForm').then((module) => module.DatosServiciosAutorizacionReportesAppSupervisorFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}